import { keepTrackApi } from '@app/keepTrackApi';
import { BaseObject, DEG2RAD, SpaceObjectType, Vector3D, calcGmst, eci2lla, lla2eci } from '@ootk/src/main';
export class MissileObject extends BaseObject {
    type = SpaceObjectType.BALLISTIC_MISSILE;
    desc;
    latList;
    lonList;
    altList;
    timeList;
    startTime;
    maxAlt;
    country;
    launchVehicle;
    lastTime;
    constructor(info) {
        super(info);
        this.id = info.id ?? 0;
        this.active = info.active;
        this.desc = info.desc;
        this.latList = info.latList;
        this.lonList = info.lonList;
        this.altList = info.altList;
        this.timeList = info.timeList;
        this.startTime = info.startTime;
        this.maxAlt = info.maxAlt;
        this.country = info.country;
        this.launchVehicle = info.launchVehicle;
    }
    isStatic() {
        return false;
    }
    isMissile() {
        return true;
    }
    getAltitude() {
        const { gmst } = calcGmst(keepTrackApi.getTimeManager().simulationTimeObj);
        const lla = eci2lla(this.position, gmst);
        return lla.alt;
    }
    getTimeInTrajectory() {
        this.lastTime ??= 0;
        for (let t = this.lastTime; t < this.altList.length; t++) {
            if (this.startTime * 1 + t * 1000 >= keepTrackApi.getTimeManager().simulationTimeObj.getTime()) {
                this.lastTime = t;
                break;
            }
        }
        return this.lastTime;
    }
    eci(t = this.getTimeInTrajectory()) {
        const { gmst } = calcGmst(keepTrackApi.getTimeManager().simulationTimeObj);
        const lat = this.latList[t];
        const lon = this.lonList[t];
        const alt = this.altList[t];
        const lla = {
            lat: (lat * DEG2RAD),
            lon: (lon * DEG2RAD),
            alt,
        };
        const eci = lla2eci(lla, gmst);
        return new Vector3D(eci.x, eci.y, eci.z);
    }
    isGoingUp() {
        const t = this.getTimeInTrajectory();
        if (this.altList[t] > this.altList[t - 1]) {
            return true;
        }
        return false;
    }
}
